import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "adv-star",
  "use": "adv-star-usage",
  "viewBox": "0 0 98 98",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 98 98\" id=\"adv-star\"><path d=\"m49.48 16.687 7.139 21.969.224.69H80.67L61.98 52.925l-.587.427.224.691 7.138 21.969-18.688-13.578-.587-.427-.588.427-18.688 13.578 7.138-21.969.225-.69-.588-.428-18.688-13.577h23.826l.224-.691 7.139-21.969Z\" stroke=\"#4FBBA4\" stroke-width=\"2\" /><rect x=\"1\" y=\"1\" width=\"96\" height=\"96\" rx=\"48\" stroke=\"#4FBBA4\" stroke-width=\"2\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol